/** Labelled switch. Extracted from ShowPersonalToggle so every opt-in filter
 *  across the app looks and behaves identically. */
import React from "react";

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  title?: string;
}

export default function Toggle({ checked, onChange, label, title }: ToggleProps) {
  return (
    <label className="flex cursor-pointer select-none items-center gap-2" title={title}>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        onClick={() => onChange(!checked)}
        className={[
          "relative inline-flex h-5 w-9 flex-shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent",
          "transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-1 focus:ring-offset-surface",
          checked ? "bg-accent" : "bg-edge-strong",
        ].join(" ")}
      >
        <span
          className={[
            "pointer-events-none inline-block h-4 w-4 transform rounded-full shadow ring-0 transition duration-200",
            // The knob must contrast with the accent fill it sits on, which is
            // brand orange; `accent-fg` is the token guaranteed to do that.
            checked ? "translate-x-4 bg-accent-fg" : "translate-x-0 bg-surface-raised",
          ].join(" ")}
        />
      </button>
      <span className="text-sm text-content-muted">{label}</span>
    </label>
  );
}
